/**
 * Передача share-id между страницами модуля через sessionStorage.
 *
 * SharedView (`/s/:shareId`) кладёт сюда id и уходит на дашборд; DashboardView
 * на монтировании забирает его и подгружает расчёт. Ключ и его стирание живут
 * отдельным модулем, а не литералом в двух страницах, потому что потребителей
 * три: обе страницы и disposeModuleState().
 *
 * Почему это вообще состояние модуля: ключ переживает unmount, а в MF-embed мы
 * делим sessionStorage со страницей платформы. Оставленный id заставил бы
 * следующий mount — возможно, уже под другим пользователем — открыть чужой
 * расчёт по чужой ссылке.
 */

/**
 * Префикс модуля обязателен: sessionStorage в embed принадлежит СТРАНИЦЕ ПЛАТФОРМЫ,
 * и безымянный `loadShareId` мог оказаться ключом хоста или соседнего ремоута — а мы
 * его читаем и стираем. Терять при переименовании нечего: значение живёт секунды
 * внутри одного перехода `/s/:shareId` → дашборд, а писатель и читатель приезжают
 * одной сборкой.
 */
export const SHARE_HANDOFF_KEY = 'idea_calc_share_handoff';

export function clearShareHandoff(): void {
  try {
    sessionStorage.removeItem(SHARE_HANDOFF_KEY);
  } catch (_) {
    /* приватный режим / отключённое хранилище — стирать нечего */
  }
}
